import { ajax } from "../../app/core/ajax";
import { alert } from "../core/alert";
import { getErrorMessage, getErrorMessageHeader } from "../core/errorHandling";
import { getErrorCode } from "../core/getErrorCode";
import * as logHelper from "../dataComponents/logHelper";

export function executeTask(args) {
    var deferred = $.Deferred(),
        errorHandled = args.errorHandled;

    args.errorHandled = true;
    args.correlationGroupId = args.correlationGroupId || kendo.guid();

    ajax(args).done(function (data) {
        var executingId = data.d.results,
            currentWaitInSeconds = 1,
            previousWaitInSeconds = 0;

        var poll = function () {
            ajax({
                url: "Executing/{0}?$expand=ExecutingResult".format(executingId),
                urlPrefix: args.urlPrefix,
                beforeSend: args.beforeSend,
                errorHandled: true,
                correlationGroupId: args.correlationGroupId,
                headers: {
                    "SPXDirty": "true" // read uncommitted
                }
            }).done(function (executingData) {
                if (executingData.d.results.ErrorCodeNumber !== null) {
                    var response = {
                        responseJSON: {
                            d: null,
                            Message: executingData.d.results.ErrorMessage,
                            Errors: {
                                General: [
                                    {
                                        Data: null,
                                        Details: executingData.d.results.ErrorMessage,
                                        Error: "GeneralException",
                                        ErrorCode: executingData.d.results.ErrorCodeNumber
                                    }
                                ],
                                Validation: []
                            }
                        }
                    };
                    deferred.reject(response);
                    logHelper && logHelper.buildLogMessage && logHelper.buildLogMessage({
                        type: "executeTask",
                        evt: {},
                        jqXHR: response,
                        ajaxSettings: args
                    });
                } else if (executingData.d.results.Done) {
                    deferred.resolve(executingData);
                } else {
                    setTimeout(poll, currentWaitInSeconds * 1000);
                    var temp = currentWaitInSeconds;
                    currentWaitInSeconds = currentWaitInSeconds < 13 ? currentWaitInSeconds + previousWaitInSeconds : 13;
                    previousWaitInSeconds = temp;
                }
            }).fail(function (result) {
                deferred.reject(result);
            });
        };

        poll();
    }).fail(function (data) {
        deferred.reject(data);
    });

    if (!errorHandled) {
        deferred.fail(function (response) {
            var errorCode = getErrorCode(response),
                header = getErrorMessageHeader({ errorCode: errorCode, defaultMessage: args.defaultErrorMessageHeader }),
                message = getErrorMessage({ errorCode: errorCode, defaultMessage: args.defaultErrorMessage });

            alert({ type: "danger", header: header, message: message });
        });
    }

    return deferred.promise();
}
